const state = {
  orders: [],
  selectedOrder: {
    Id: '',
    OrderNumber: '',
    Reference: '',
  },
  selectedFullOrder: {
    SalesOrderId: '',
    OrderNumber: '',
    CustomerReference: '',
    GrandTotal: 0,
    Customer: {
      Email: '',
    },
  },
}

const getters = {
  orders: (state) => {
    return state.orders
  },
  selectedOrder: (state) => {
    return state.selectedOrder
  },
  selectedFullOrder: (state) => {
    return state.selectedFullOrder
  },
}

const actions = {
  reset({ commit }) {
    commit('reset')
  },
  setSelectedOrder({ commit }, order) {
    commit('setSelectedOrder', order)
  },
  setSelectedFullOrder({ commit }, order) {
    commit('setSelectedFullOrder', order)
  },
}

const mutations = {
  reset(state) {
    state.orders = []
    state.invoices = []
    state.selectedOrder = {}
    state.selectedFullOrder = {}
  },
  setOrders(state, orders) {
    state.orders = orders
  },
  setSelectedOrder(state, order) {
    state.selectedOrder = order
  },
  setSelectedFullOrder(state, order) {
    state.selectedFullOrder = order
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
